/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export interface Address {
  /** @nullable */
  city?: string;
  /** @nullable */
  country?: string;
  /** @nullable */
  line1?: string;
  /** @nullable */
  line2?: string;
  /** @nullable */
  postalCode?: string;
  /** @nullable */
  province?: string;
}
